var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeartIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "black",
    fillOpacity: 0.14
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 15.1649C30 17.0551 29.2874 18.8706 28.015 20.2136C25.0859 23.3059 22.2449 26.5305 19.2064 29.5108C18.5099 30.184 17.405 30.1594 16.7386 29.4558L7.98451 20.2136C5.3385 17.4199 5.3385 12.91 7.98451 10.1164C10.6565 7.29533 15.0095 7.29533 17.6815 10.1164L17.9998 10.4523L18.3178 10.1166C19.5989 8.76328 21.3437 8 23.1664 8C24.989 8 26.7337 8.7632 28.015 10.1164C29.2876 11.4594 30 13.2748 30 15.1649Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartIcon);
export default __webpack_public_path__ + "static/media/heartIcon.72373291b123ea0738b1385c96d178dd.svg";
export { ForwardRef as ReactComponent };